/* eslint-disable tailwindcss/no-custom-classname */
import type { MouseEventHandler } from 'react';
import { hasRenderableCta } from '../helpers';
import type {
  ProductGridCardCtaPosition,
  ProductGridCardPrimaryCtaIcon,
} from '../types';
import { ProductGridCardCta } from './ProductGridCardCta';

type ProductGridCardActionsProps = {
  primaryCtaLabel?: string;
  primaryCtaUrl?: string;
  onPrimaryCtaClick?: MouseEventHandler<HTMLElement>;
  primaryCtaPosition: ProductGridCardCtaPosition;
  primaryCtaIcon: ProductGridCardPrimaryCtaIcon;
  secondaryCtaLabel?: string;
  secondaryCtaUrl?: string;
  onSecondaryCtaClick?: MouseEventHandler<HTMLElement>;
  placement: ProductGridCardCtaPosition;
};

export const ProductGridCardActions = ({
  primaryCtaLabel,
  primaryCtaUrl,
  onPrimaryCtaClick,
  primaryCtaPosition,
  primaryCtaIcon,
  secondaryCtaLabel,
  secondaryCtaUrl,
  onSecondaryCtaClick,
  placement,
}: ProductGridCardActionsProps) => {
  const shouldRenderPrimary =
    primaryCtaPosition === placement &&
    hasRenderableCta(primaryCtaLabel, primaryCtaUrl, onPrimaryCtaClick);
  const shouldRenderSecondary =
    placement === 'footer' &&
    hasRenderableCta(secondaryCtaLabel, secondaryCtaUrl, onSecondaryCtaClick);

  if (!shouldRenderPrimary && !shouldRenderSecondary) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 sm:gap-spacing/gap/soft-8px">
      {shouldRenderPrimary && primaryCtaLabel && (
        <ProductGridCardCta
          label={primaryCtaLabel}
          href={primaryCtaUrl}
          onClick={onPrimaryCtaClick}
          icon={primaryCtaIcon}
        />
      )}

      {shouldRenderSecondary && secondaryCtaLabel && (
        <ProductGridCardCta
          label={secondaryCtaLabel}
          href={secondaryCtaUrl}
          onClick={onSecondaryCtaClick}
          variant="outline"
          styleType="neutral-light-and-blue"
        />
      )}
    </div>
  );
};
